export default __webpack_public_path__ + "static/pilot-Jameel-4488aa37cdacefc35cb99b0dd6555cf9.png";